module.exports = __webpack_public_path__ + "static/FoundersGrotesk-RegularItalic-ee230ee9b5ff36db357771eaa9916a3c.eot";